import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "components/MDButton";

interface PaymentResultModalProps {
  open: boolean;
  success: boolean;
  onClose: () => void;
}

const PaymentResultModal: React.FC<PaymentResultModalProps> = ({
  open,
  success,
  onClose
}) => {
  const handleClose = () => {
    window.history.replaceState(null, "", "/dashboard");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          minWidth: 360,
          textAlign: "center",
          outline: "none"
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        {success ? (
          <>
            <CheckCircleIcon
              color="primary"
              fontSize="large"
              sx={{
                mb: 2,
                mt: 1,
                ".MuiSvgIcon-fontSizeLarge": {
                  fontSize: "80px"
                }
              }}
            />
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Payment Setup Successful!
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
              Your StmpZ subscription is now active.
            </Typography>
            <MDButton
              variant="contained"
              color="primary"
              onClick={handleClose}
              fullWidth
              sx={{ mt: 2, fontWeight: 600 }}
            >
              Done
            </MDButton>
          </>
        ) : (
          <>
            <ErrorIcon
              color="error"
              fontSize="large"
              sx={{ fontSize: 56, mb: 2, mt: 1 }}
            />
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Payment Setup Failed
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
              There was an issue setting up your payment. Please try again or
              contact support for assistance at info@stmpz.com
            </Typography>
            <MDButton
              variant="contained"
              color="primary"
              onClick={handleClose}
              fullWidth
              sx={{ mt: 2, fontWeight: 600 }}
            >
              Done
            </MDButton>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default PaymentResultModal;
